import { FormEvent, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { BrandMark, ReticleIcon } from '../components/primitives';

export default function LoginPage() {
  const { login, isLoading } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    const result = await login(username.trim(), password);
    if (!result.success) {
      setError('message' in result ? result.message : 'Unable to sign in.');
      return;
    }
    setPassword('');
  };

  return (
    <main className="login-shell">
      <div className="login-shell__watermark" aria-hidden="true">
        <ReticleIcon size={520} stroke={1} />
      </div>
      <div className="login-shell__gradient" aria-hidden="true" />

      <form className="login-form" onSubmit={handleSubmit}>
        <div className="login-form__header">
          <BrandMark size={56} withWordmark={false} />
          <h1 className="login-form__title">A.R.E.S</h1>
          <p className="login-form__tagline">Anesthesia Remote Emergency Supervision.</p>
        </div>

        <div className="login-form__fields">
          <div className="field">
            <label htmlFor="login-username" className="field__label">
              Username
            </label>
            <input
              id="login-username"
              name="username"
              type="text"
              className="field__input"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                setError(null);
              }}
              autoComplete="username"
              autoFocus
              required
              disabled={isLoading}
            />
          </div>
          <div className="field">
            <label htmlFor="login-password" className="field__label">
              Password
            </label>
            <input
              id="login-password"
              name="password"
              type="password"
              className="field__input"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(null);
              }}
              autoComplete="current-password"
              required
              disabled={isLoading}
            />
          </div>
        </div>

        {error && (
          <div className="login-form__error" role="alert">
            {error}
          </div>
        )}

        <div className="login-form__submit">
          <button
            type="submit"
            className="btn btn--primary btn--lg btn--block"
            disabled={isLoading}
            aria-busy={isLoading || undefined}
          >
            {isLoading ? 'Signing in…' : 'Sign in'}
          </button>
        </div>

        <div className="login-form__footer">
          <a href="#" onClick={(e) => e.preventDefault()}>
            Need help signing in?
          </a>
        </div>
      </form>

      <footer className="login-shell__footer">A.R.E.S · Secure clinical link</footer>
    </main>
  );
}
